module.exports = __webpack_public_path__ + "images/bc0b4d5615c8d76ccfb6f739fa80ed2f.png";